import { formatNumber } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { LOCALE_ID, ViewEncapsulation } from '@angular/core';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import moment from 'moment';
import { AppService } from 'src/app/_services/app.service';
import { ReportsComponent } from '../reports.component';

@Component({
    selector: 'app-show-report',
    templateUrl: './show-report.component.html',
  styleUrls: ['./show-report.component.scss'],
    standalone: false
})
export class ShowReportComponent implements OnInit, AfterViewInit {

  selectedReportProperties: ReportProperties;

  searchParameters: ReportSearchParameters;
  isSelectedReport: boolean = false;
  isGeneratedReport: boolean = false;
  dataSource;
  displayColumnsDynamic: string[] = [];
  displayFiltersDynamic: Column[] = [];
  displayColumnsFiltersDynamic: string[] = [];
  resultLength: number = 0;
  mattablePageSize = 30;
  loading: boolean = false;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(@Inject(LOCALE_ID) private locale: string, @Inject('BASE_URL') private baseUrl: string, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, public dialogRef: MatDialogRef<ReportsComponent>, public service: AppService) { }

  ngOnInit() {
    this.InitializeParameters();
  }

  ngAfterViewInit() {
    this.InitializeShow();
  }

  /** Initializes the parameters */
  InitializeParameters() {
    this.selectedReportProperties = this.data.selectedReportProperties;
    this.searchParameters = this.data.searchParameters;
  }

  /** Click event for a reports */
  InitializeShow() {
    let canProceed: boolean = true;
    if ((this.selectedReportProperties.hasAccounts === true && !this.searchParameters.selectedAccount)
    || (this.selectedReportProperties.hasMarkets === true && !this.searchParameters.selectedMarket)
    || (this.selectedReportProperties.hasInstruments === true && !this.searchParameters.selectedInstrument)) {
      canProceed = false;
    }

    if (canProceed === true) {
      this.GetReportDetails();

      // If the user changes the sort order, reset back to the first page.
      this.sort.sortChange.subscribe(() => {
        this.paginator.pageIndex = 0;
        this.ApplyFilterOptions(false, null);
      });

      this.paginator.page.subscribe(() => {
        this.ApplyFilterOptions(false, null);
      });
    }
  }

  /**
   *  Initializea a given column
   * @param column Given column
   */
  InitializeColumn(column: Column) {
    let filterType: string = '';
    if (column.type === 'text' || column.type === 'number') {
      filterType = 'temp';
    } else {
      filterType = column.type;
    }

    if (column.filter) {
      if (!column.filter.filterEnabled) {
        column.filter.filterEnabled = false;
      }
      if (!column.filter.filterType) {
        column.filter.filterType = filterType;
      }
      if (!column.filter.filterValue || (column.type === 'bool' && !this.service.getBoolean(column.filter.filterValue))) {
        column.filter.filterValue = '';
      }
    } else {
      column.filter = {
        filterEnabled: false,
        filterType: filterType,
        filterValue: ''
      };
    }
  }

  /**
   * Fires when data bounds to the table cell
   * @param column column 
   * @param element element details
   */
  OnDataBound(column: string, element: any): any {
    let currentVal = element[column];
    if (!isNaN(currentVal) && currentVal !== '') {
      let temp: string = currentVal;
      if (temp.includes('.')) {
        temp = temp.replace('-', '');
        const beforeDec = temp.split('.')[0].length.toString();
        const afterDec = temp.split('.')[1].length.toString();
        currentVal = formatNumber(currentVal, this.service.getLocalLanguage(), beforeDec + '.' + afterDec + '-' + afterDec);
      }
    }
    return currentVal;
  }

  /** Gets the report details */
  GetReportDetails() {
    if (this.loading === false) {
      if (this.dataSource) {
        this.dataSource = [];
      }
      this.isGeneratedReport = true;
      this.loading = true;
      const currentColumns: Column[] = this.displayFiltersDynamic;
      this.displayColumnsDynamic = [];
      this.displayFiltersDynamic = [];
      this.displayColumnsFiltersDynamic = [];
      this.searchParameters.properties = JSON.parse(JSON.stringify(this.selectedReportProperties));

      if (currentColumns.length > 0) {
        // this.searchParameters.properties.columns = currentColumns;
        const tempColumns: Column[] = JSON.parse(JSON.stringify(this.selectedReportProperties.columns));
        this.searchParameters.properties.columns.forEach(ele => {
          if (ele.enabled === true) {
            const columnLatest = currentColumns.find(o => o.columnId === ele.columnId);
            if (columnLatest) {
              const columnPrevious = tempColumns.find(o => o.columnId === ele.columnId);
              const index = tempColumns.indexOf(columnPrevious, 0);
              tempColumns.splice(index, 1, columnLatest);
            }
          }
        });

        this.searchParameters.properties.columns = tempColumns;
      }

      const oldDateFrom = this.searchParameters.dateFrom;
      const oldDateTo = this.searchParameters.dateTo;
      const momentUtcFrom = moment(this.searchParameters.dateFrom);
      const momentUtcTo = moment(this.searchParameters.dateTo);
      this.searchParameters.dateFrom = new Date(Date.UTC(momentUtcFrom.year(), momentUtcFrom.month(), momentUtcFrom.date(), momentUtcFrom.hours(), momentUtcFrom.minutes(), momentUtcFrom.seconds()));
      this.searchParameters.dateTo = new Date(Date.UTC(momentUtcTo.year(), momentUtcTo.month(), momentUtcTo.date(), momentUtcTo.hours(), momentUtcTo.minutes(), momentUtcTo.seconds()));

      this.http.post<Report>(this.baseUrl + 'api/reports/generateReport/' + this.sort.active + '/' + this.sort.direction + '/' + this.paginator.pageIndex + '/' + this.paginator.pageSize, this.searchParameters).subscribe(result => {
        this.resultLength = result.totalCount;

        result.columns.forEach(o => {
          this.InitializeColumn(o);
          this.displayColumnsDynamic.push(o.name);
          this.displayColumnsFiltersDynamic.push(o.name + ' Filter');
          this.displayFiltersDynamic.push(o);
        });


        this.dataSource = result.data;
      }, error => {
          console.error(error);
      }).add(() => {
        this.loading = false;
        this.searchParameters.dateFrom = oldDateFrom;
        this.searchParameters.dateTo = oldDateTo;
      });
    }
  }

  /**
   * Applying filter options
   * @param opened whether the popup window opened or closed
   * @param column selected column
   */
  ApplyFilterOptions(opened: boolean, column: Column) {
    if (!opened) {
      if (column == null) {
        this.GetReportDetails();
      } else {
        if (column.filter.filterType !== 'temp' && column.filter.filterValue.toString().trim() !== '') {
          column.filter.filterValue = column.filter.filterValue.toString();
          if (column.filter.filterType === 'date') {
            column.filter.filterValue = moment(column.filter.filterValue).toISOString();
          }
          this.GetReportDetails();
        } else {
          this.GetReportDetails();
        }
      }
    }
  }

  /** Functions to execute when page size changed */
  OnPagesizeChange() {
    this.paginator.pageSize = this.mattablePageSize;
    this.paginator.pageIndex = 0;
    this.ApplyFilterOptions(false, null);
  }

  /**
   *  Resets the date filter
   * @param column Selected column
   */
  ResetDateFilter(column: Column) {
    column.filter.filterValue = null;
    this.ApplyFilterOptions(false, null);
  }

  /** Exports the data to excel */
  OnClickExport() {
    const oldDateFrom = this.searchParameters.dateFrom;
    const oldDateTo = this.searchParameters.dateTo;
    const momentUtcFrom = moment(this.searchParameters.dateFrom);
    const momentUtcTo = moment(this.searchParameters.dateTo);
    this.searchParameters.dateFrom = new Date(Date.UTC(momentUtcFrom.year(), momentUtcFrom.month(), momentUtcFrom.date(), momentUtcFrom.hours(), momentUtcFrom.minutes(), momentUtcFrom.seconds()));
    this.searchParameters.dateTo = new Date(Date.UTC(momentUtcTo.year(), momentUtcTo.month(), momentUtcTo.date(), momentUtcTo.hours(), momentUtcTo.minutes(), momentUtcTo.seconds()));

    this.service.showSpinner();
    this.http.post(this.baseUrl + 'api/reports/exportData', this.searchParameters, { responseType: 'text'}).subscribe(result => {
      if (result !== '') {
        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.download = 'Report Export.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
        document.removeChild(anchor);
      } else {
        this.service.SaveStatus(false, 'Messages.msgHeaderExport', 'Messages.msgErrorTryAgain');
      }
    }, error => {
      console.error(error);
    }).add(() => {
      this.service.hideSpinner();
      this.searchParameters.dateFrom = oldDateFrom;
      this.searchParameters.dateTo = oldDateTo;
    });
  }

  /** Cick event for the close button */
  OnClickClose() {
    this.dialogRef.close();
  }

}

/** An interface to access report details response from server */
interface Report {
  totalCount: number;
  data: any;
  columns: Column[];
}

/** An interface to access report properties */
interface ReportProperties {
  reportId: string;
  name: string;
  columns: Column[];
  sqlQuery: string;
  hasMarkets: boolean;
  hasInstruments: boolean;
  hasAccounts: boolean;
}

/** An interface to access report search parameters */
interface ReportSearchParameters {
  properties: ReportProperties;
  dateFrom: Date;
  dateTo: Date;
  selectedMarket: string;
  selectedInstrument: string;
  selectedAccount: string;
  selectedSummary: boolean;
}

/** An interface to access column details */
interface Column {
  columnId: string;
  name: string;
  enabled: boolean;
  type: string;
  filter: ColumnFilter;
}

/** An interface to access filter details */
interface ColumnFilter {
  filterValue: string;
  filterType: string;
  filterEnabled: boolean;
}
